import { Button, Modal } from "@etudescarre/ui";

export type DestinataireData = {
  teamName: string;
  bordereauNumero: string | null;
  etatTransmission: string;
  commentaire: string | null;
};

export type DestinatairesPopupProps = {
  open: boolean;
  onClose: () => void;
  documentName: string;
  type: "avis" | "coordination";
  destinataires: DestinataireData[];
};

const transmissionLabels: Record<string, string> = {
  en_construction: "En construction",
  a_envoyer: "À envoyer",
  envoye: "Envoyé",
};

export function DestinatairesPopup({
  open,
  onClose,
  documentName,
  type,
  destinataires,
}: DestinatairesPopupProps) {
  return (
    <Modal.Root open={open} onOpenChange={(e) => !e.open && onClose()}>
      <Modal.Backdrop />
      <Modal.Positioner>
        <Modal.Content size="xl">
          <Modal.Header>
            <Modal.Title>
              Destinataires{" "}
              {type === "avis" ? "pour avis" : "pour coordination"}
            </Modal.Title>
          </Modal.Header>

          <div className="px-6 pb-6">
            <p className="mb-4 text-sm text-zinc-600 dark:text-zinc-400">
              {documentName}
            </p>

            {destinataires.length === 0 ? (
              <p className="text-sm text-zinc-500">Aucun destinataire.</p>
            ) : (
              <table className="w-full text-sm border-collapse">
                <thead>
                  <tr className="border-b border-zinc-200 dark:border-zinc-700">
                    <th className="px-3 py-2 text-left font-medium text-zinc-700 dark:text-zinc-300">
                      Destinataire
                    </th>
                    <th className="px-3 py-2 text-left font-medium text-zinc-700 dark:text-zinc-300">
                      Bord. N°
                    </th>
                    <th className="px-3 py-2 text-left font-medium text-zinc-700 dark:text-zinc-300">
                      État transmission
                    </th>
                    <th className="px-3 py-2 text-left font-medium text-zinc-700 dark:text-zinc-300">
                      Commentaire
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {destinataires.map((d, i) => (
                    <tr
                      key={`${d.teamName}-${i}`}
                      className="border-b border-zinc-100 dark:border-zinc-700/50"
                    >
                      <td className="px-3 py-2 text-zinc-800 dark:text-zinc-200">
                        {d.teamName}
                      </td>
                      <td className="px-3 py-2 text-zinc-600 dark:text-zinc-400">
                        {d.bordereauNumero ?? "-"}
                      </td>
                      <td className="px-3 py-2">
                        <span
                          className={
                            d.etatTransmission === "envoye"
                              ? "text-green-600"
                              : "text-amber-600"
                          }
                        >
                          {transmissionLabels[d.etatTransmission] ??
                            d.etatTransmission}
                        </span>
                      </td>
                      <td className="px-3 py-2 text-zinc-600 dark:text-zinc-400 max-w-[200px] truncate">
                        {d.commentaire ?? "-"}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
          <Modal.Footer>
            <Button onClick={onClose}>Fermer</Button>
          </Modal.Footer>
        </Modal.Content>
      </Modal.Positioner>
    </Modal.Root>
  );
}
